<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Credit Payment
    </h2>
    <hr />
    <mat-dialog-content class="ps-6 pt-2 mat-typography">
        <form [formGroup]="form" class="flex flex-col space-y-5 w-full">
            @if (
                creditInformationResponse &&
                creditInformationResponse.cardType &&
                creditInformationResponse.truncatedCardNumber
            ) {
                <div
                    class="flex flex-col divide-y divide-gray-200 border border-solid border-gray-200 rounded-lg overflow-hidden"
                >
                    <div class="flex items-center px-4 py-3 gap-3">
                        <div
                            class="w-10 h-6 bg-white border border-gray-200 rounded flex items-center justify-center shrink-0"
                        >
                            <app-card-type-icon
                                [cardType]="creditInformationResponse.cardType"
                            />
                        </div>
                        <div class="flex flex-col">
                            <span class="text-sm font-medium text-gray-800">
                                Ending in
                                {{
                                    creditInformationResponse.truncatedCardNumber
                                }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="flex flex-col gap-1">
                    <span
                        class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        Maximum amount available to credit:
                    </span>
                    <span class="text-2xl font-medium text-gray-900">
                        {{
                            creditInformationResponse.remainingCredit | currency
                        }}
                    </span>
                </div>

                <div class="flex flex-col space-y-1">
                    @if (isCreditOperationPermitted()) {
                        @if (hasRemainingAmountToCredit()) {
                            <mat-form-field
                                appearance="outline"
                                subscriptSizing="dynamic"
                                class="w-full"
                            >
                                <mat-label>Credit Amount</mat-label>
                                <input
                                    matInput
                                    title="Amount to credit"
                                    [formControl]="form.controls.amount"
                                    [imask]="paymentTransactionAmountMaskConfig"
                                    [unmask]="'typed'"
                                />
                                @if (getAmountMaxError(); as error) {
                                    <mat-error>{{ error }}</mat-error>
                                }
                            </mat-form-field>
                        } @else {
                            <span class="text-sm text-gray-600">
                                There is no remaining credit available to be
                                credited back to the customer for this payment
                                transaction.
                            </span>
                        }
                    } @else {
                        <span class="text-sm text-gray-600">
                            You do not have the necessary permissions to perform
                            credit operations. Please contact accounting or your
                            system administrator for assistance.
                        </span>
                    }
                </div>
            }
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!pb-5 !pr-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="cancel()"
        >
            Cancel
        </button>

        @if (hasRemainingAmountToCredit()) {
            <button
                mat-raised-button
                type="button"
                name="Save"
                cdkFocusInitial
                color="primary"
                [disabled]="!creditInformationResponse || form.invalid"
                (click)="save()"
            >
                Credit
            </button>
        }
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
